<template>

<div class="input-group date datepicker position-relative " style="z-index:auto" v-bind:class="[classstyle]" @click="requestPicker($event)" v-click-outside="clickOutsidePicker">
        <input type="text" class="form-control" :placeholder="this.format" v-bind:class="[classinput]" v-on:change="onChange($event)" v-model="displayDate" v-on:blur="onBlur()">
        <div class="input-group-append" v-show="!disabledicon">
            <div class="input-group-text">
                <i v-bind:class="icon"></i>
            </div>
        </div>
    </div>

    
</template>

<script>
    export default {
        props: {
            usecurrent: { default: function () { return true; }},
            classstyle: { default: function () { return ''; }},
            classinput: { default: function () { return ''; }},
            value: {
                default: ''
            },
            format: {
                default: 'DD/MM/YYYY'
            },
            step: {
                default: '5'
            },
            icon: {
                default: 'far fa-calendar-alt'
            },
            disabledicon: {
                default: false
            },
            mindate: {
                default: function () {
                    return false;
                }
            }
        },
        data: function(){
            return {
                show:false,
                cuDate:null,
                currentFormat: '',
                displayDate:''
            }
            
        },
        watch: { 
            value: function(newVal, oldVal) { 
                if (newVal && newVal instanceof Date) {
                    if (this.mindate > newVal) {
                        this.$emit("data-out-range", {
                            minDate : this.mindate,
                            desideredDate : newVal,
                            el:this
                        });
                        newVal = new Date();
                    }
                    this.displayDate = moment(newVal).format(this.currentFormat);;
                    $(this.$el).datetimepicker('date', newVal);
                    
                } else {
                    this.displayDate = '';
                    $(this.$el).datetimepicker('date', null);
                }
            },
            mindate: function(newval,oldbalue) {
                this.mindate = newval;
                this.loadPicker();
            }
        },
        mounted(){
            this.currentFormat = this.format;
            
            this.loadPicker();

            this.$on('click-outside', this.clickOutsidePicker);
        },
    methods: {
        loadPicker() {
            $(this.$el).datetimepicker({
                format:this.currentFormat,
                stepping:this.step,
                useCurrent: this.usecurrent
            });
            const minDate = this.mindate ? this.mindate : false;
            $(this.$el).data("datetimepicker").minDate(minDate)
            $(this.$el).on("change.datetimepicker", ({date, oldDate}) => {
                const newDate = date ? moment(date).toDate() : null;
                this.runChangeEvent(newDate);
                this.cuDate= newDate;
                this.show = false;
            });
            $(this.$el).on("show.datetimepicker", (e) => {
                let datepicker = $('body').find('.bootstrap-datetimepicker-widget:last');
                if (datepicker.hasClass('bottom')) {
                    let top = $(e.target).outerHeight();
                    datepicker.css({
                        'top': top + 'px',
                    });
                }
            });
            if (this.value && this.value instanceof Date) {
                if (minDate && minDate > this.value) this.value = new Date(this.mindate)
                
                $(this.$el).datetimepicker('date', this.value);
            }
        },
        runChangeEvent(newDate) {
            if (newDate == this.cuDate) return;
            this.$emit("on-update", {
                newDate : newDate,
                oldDate : this.cuDate,
                curFormat: this.currentFormat,
                displayDate:this.displayDate
            });
        },
        onChange(ev) {
            
            const tmp = moment(ev.target.value, this.currentFormat).format(this.currentFormat);
            if (tmp != ev.target.value) return;
            this.displayDate = tmp;
            const newDate = ev.target.value ? moment(tmp, this.currentFormat).toDate() : null;
            this.runChangeEvent(newDate);
            
        },
        toggleDialog: function() {
            $(this.$el).datetimepicker('toggle');
        },
        openDialog: function() {
            if (this.show) return;
            $(this.$el).datetimepicker('show');
            this.show = true;
        },
        hideDialog: function() {
            this.show = false;
            $(this.$el).datetimepicker('hide');
        },

        requestPicker: function(ev) {
            this.openDialog();
            ev.stopPropagation();
        },
        onBlur: function() {
            this.hideDialog();
            //this.$el.firstChild.value;
        },
         clickOutsidePicker: function () {
            this.hideDialog();
            
        }
    }
    
    
    }
</script>
